export const cleanPhoneNumber = (phoneNumber: string): string => {
  const startsWithPlus = phoneNumber.startsWith('+');
  let cleaned = phoneNumber.replace(/\D/g, '');
  if (startsWithPlus) {
    cleaned = '+' + cleaned;
  }
  return cleaned;
};
